goog.module('yext.scheduledupdates.dialog.RevertDialog');
goog.module.declareLegacyNamespace();

const notify = goog.require('yext.notify');
const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const Base = goog.require('yext.scheduledupdates.dialog.Base');
const ValidationErrorDialog = goog.require('yext.scheduledupdates.dialog.ValidationErrorDialog');
const time = goog.require('yext.time');
const DatePicker = goog.require('yext.scheduledupdates.DatePicker');


/**
  * Creates a Revert Update dialog
  * Note that either fieldIds or entityFieldIds must be non-empty, depending on the context this
  * dialog is being used in.
  *
  * @param {!Array}    fieldIds          Array of fieldIds (Integers) to revert.
  * @param {!Array}    customFieldIds    Array of customFieldIds (Longs) to revert.
  * @param {string}    minDate           the earliest available date on the calendar
  * @param {!Array}    entityFieldIds    Array of the entityManagerIds (Strings) to revert.
  *
  * @constructor
  * @suppress {deprecated}
  */
const RevertDialog = function(fieldIds, customFieldIds, minDate, entityFieldIds) {
  var $dialog = $('.js-revert-update-dialog');
  var $submit = $dialog.find('.js-submit-btn');
  var $datepicker = $dialog.find('.js-datepicker-input');
  var $revertOptions = $dialog.find('input[name="revert-scheduled-updates-option"]');
  var $revertEnabledButton = $revertOptions.filter('input[value="YES"]');
  var $revertDisabledButton = $revertOptions.filter('input[value="NO"]');
  var localMinDate = new Date(minDate);
  // the datepicker widget only display date in GMT, so we force the date to be the current timezone
  localMinDate.setMinutes(localMinDate.getMinutes() + localMinDate.getTimezoneOffset());

  var $yextDatePicker = new DatePicker(
    $datepicker,
    $submit,
    {minDate: localMinDate, disabled: true},
    function(inputDate) {
      return inputDate >= localMinDate;
    });

  var isRevertSelected = function() {
    return $revertEnabledButton.prop('checked');
  };

  var getDate = function() {
    return $yextDatePicker.parseDate();
  };

  var isDateSelected = function() {
    return getDate() != null;
  };

  var updateEnabledStatus = function() {
    if (isRevertSelected()) {
      // Revert is selected.
      $datepicker.datepicker('enable');
      $datepicker.datepicker('show');

      if (isDateSelected()) {
        $submit.prop('disabled', false);
      } else {
        $submit.prop('disabled', true);
      }
    } else {
      // Revert is not requested.
      $datepicker.datepicker('disable');
      $submit.prop('disabled', false);
    }
  };

  var hideDialog = function() {
    $dialog.dialog('close');
  };

  var resetDialog = function() {
    // TODO (egurevich): seems like the suggested way to handle 'reset' is
    // to rebuild the whole dialog from scratch each time using the <script> tag
    // (see dialog.soy/.viewScheduledUpdates for an example)
    // This approach was considered and it was decided to stick to 'manual reset' for now, but
    // if issues arise, the script tag approach should be revisited.
    $datepicker.datepicker('setDate', null);
    $revertDisabledButton.prop('checked', true);
    updateEnabledStatus();
  };

  resetDialog();

  // Fires on change in the selected radio button options
  $revertOptions.change(function() {
    updateEnabledStatus();
  });

  // Fires when the area around the datepicker is clicked.
  // (datepicker.click doesn't fire when datepicker is disabled, hence this approach)
  $datepicker.parent().click(function() {
    $revertEnabledButton.prop('checked', true);
    updateEnabledStatus();
  });

  var url = yext.scheduledupdates.routes.revert() + window.location.search;

  var scheduleRevert = function(revertDate) {
    revertDate = time.formatDateIso(revertDate);
    var isBulk = $dialog.data('isbulk');

    // Construct revertParams to be sent to server
    var revertParams = {
      updateDate: yext.getUrlParams().date,
      fieldIds: fieldIds,
      entityFieldIds: entityFieldIds,
      customFieldIds: customFieldIds,
      revertDate: revertDate,
      overrideExisting: false,
    };

    var makeRequest = function() {
      self.dialogTimeout = dialog.showDelayedProgressDialog(yext.msg('Saving...'));

      $.ajax({
        url: url,
        type: 'POST',
        data: revertParams,
        async: true,
        success: function(result) {
          if (result.status == 'SUCCESS') {
            notify.showSuccess(yext.msg('Successfully scheduled a revert operation. The page will reload momentarily.'));

            // Refresh the page (to show the [potentially] new future date on the sidebar)
            setTimeout(function() {
              window.location.reload(true);
            },
            2000);
          } else if (result.status == 'OVERRIDE_REQUIRED') {
            revertParams.overrideExisting = true;
            yext.scheduledupdates.dialog.OverrideUpdateDialog(makeRequest);
          } else if (result.status == 'FAILURE') {
            if (isBulk) {
              // Bulk Validation error handling
              var bulkErrorDialog;
              if (entityFieldIds) {
                bulkErrorDialog = yext.msg('Your selected fields cannot be reverted to {0} because ' +
                  'there are errors in one or more of your bulk selected fields. ' +
                  'To view the errors, reschedule them by each entity individually.',
                time.formatLocalizedDate(revertDate, 'medium'));
              } else {
                bulkErrorDialog = yext.msg('Your selected fields cannot be reverted to {0} because ' +
                    'there are errors in one or more of your bulk selected fields. ' +
                    'To view the errors, reschedule them by each location individually.',
                time.formatLocalizedDate(revertDate, 'medium'));
              }
              dialog.showErrorDialog(bulkErrorDialog, yext.msg('Scheduled Updates Errors'));
            } else if (result.errors && entityFieldIds) {
              // Entity Validation error handling
              const updatedFieldCount = entityFieldIds.length;
              new ValidationErrorDialog(entityFieldIds.length, result.errors, revertDate).show();
            } else if (result.data) {
              // Location Validation error handling
              var updatedFieldCount = fieldIds.length;
              if (customFieldIds && customFieldIds.length > 0) {
                updatedFieldCount += customFieldIds.length - 1;
              }
              new ValidationErrorDialog(updatedFieldCount, result.data, revertDate).show();
            } else {
              dialog.showErrorDialog(yext.msg(
                'Your selected fields cannot be reverted to {0} because there are errors in one or more of your selected fields.',
                time.formatLocalizedDate(revertDate, 'medium')),
              yext.msg('Scheduled Updates Errors'));
            }
          } else {
            // TODO (egurevich): this should only happen on timeout (meaning our logic is stuck somewhere or
            // an unhandled exception was thrown); is there a way to get an alert if it does?
            // https://yexttest.atlassian.net/browse/TB-7692
            dialog.showErrorDialog(yext.msg('Error scheduling reverts'));
          }
        },
        error: function() {
          dialog.showErrorDialog(yext.msg('Error scheduling reverts'));
        },
        complete: function(result, status) {
          dialog.hideDelayedProgressDialog(self.dialogTimeout);
          // hide the revert dialog if the status is not OVERRIDE_REQUIRED
          if (!(result.responseJSON && result.responseJSON.status == 'OVERRIDE_REQUIRED')) {
            hideDialog();
          }
        },
      });
    };

    makeRequest();
  };

  // Fires on submit button click
  $dialog.off('submit').on('submit', function() {
    if (isRevertSelected()) {
      $submit.prop('disabled', true);
      scheduleRevert(getDate());
    } else {
      hideDialog();
    }
  });

  var options = {
    container: $dialog,
    title: yext.msg('Revert Back to Original Content'),
    unbindOnClose: true,
    keepOpenOnSubmit: true,
  };

  new Base(options).show();
};

exports = RevertDialog;
